import { Link, NavLink } from "react-router-dom";
import ImgGramInfoPage from "./ImgGramInfoPage";

const GrampanchayatSuchana = () => {
    return (
        <div className="max-w-5xl mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold mb-6 text-left"> ग्रामपंचायत अधिसूचना चांडोली खुर्द ता.आंबेगाव जि.पुणे</h1>
            <div className="h-0.5 w-full bg-orange-500 mb-6"></div>
            <img 
            className="w-full h-auto object-contain"
            src="/adhisuchana-img.jpeg"/>
        </div>
    );
}

export default GrampanchayatSuchana;